import { render, staticRenderFns } from "./OfferListItem.vue?vue&type=template&id=00422502&scoped=true"
import script from "./OfferListItem.vue?vue&type=script&lang=js"
export * from "./OfferListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00422502",
  null
  
)

export default component.exports